import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';

/**
 * Boardriders registration profile fields (postal code, date of birth, phone).
 *
 * Rendered through the `sfcc.userRegistration.loyalty.enrollment` UITarget so the core
 * signup-form component is never edited — future Storefront Next template updates stay
 * conflict-free. The inputs live inside the registration <Form>, so their values are
 * submitted with the signup action, which reads `postalCode`, `birthday` and `phone`.
 */
export default function RegistrationFields(): ReactElement {
    const { t } = useTranslation('signup');

    return (
        <div className="space-y-6" data-section="registration-profile-fields">
            <div>
                <label htmlFor="postalCode" className="block text-sm font-medium text-foreground">
                    {t('form.postalCodeLabel')}
                </label>
                <Input
                    id="postalCode"
                    name="postalCode"
                    type="text"
                    inputMode="numeric"
                    autoComplete="postal-code"
                    required
                    className="mt-1"
                    placeholder={t('form.postalCodePlaceholder')}
                />
            </div>

            <div>
                <label htmlFor="birthday" className="block text-sm font-medium text-foreground">
                    {t('form.birthdayLabel')}
                </label>
                <Input id="birthday" name="birthday" type="date" autoComplete="bday" required className="mt-1" />
            </div>

            <div>
                <label htmlFor="phone" className="block text-sm font-medium text-foreground">
                    {t('form.phoneLabel')}
                </label>
                <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    autoComplete="tel"
                    required
                    className="mt-1"
                    placeholder={t('form.phonePlaceholder')}
                />
            </div>
        </div>
    );
}
